import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IContactFormValues } from '../../components/VenueContactModal/types';
import { createVenueAddress } from '../../api/createVenueAddress';
import { updateVenueAddress } from '../../api/updateVenueAddress';
import { deleteVenueAddress } from '../../api/deleteVenueAddress';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { posthog } from 'posthog-js';

const doesSubmissionHaveValues = (data: IContactFormValues) => {
  const values = Object.values(data);
  for (let i = 0; i < values.length; i++) {
    if (values[i] !== '' && values[i] !== null) {
      return true;
    }
  }
  return false;
};
export const useUpdateVenueContact = (venueId: string, onSuccess: () => void, addressId?: string) => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();
  return useMutation({
    mutationFn: (data: IContactFormValues) => {
      const hasValues = doesSubmissionHaveValues(data);
      if (!addressId && hasValues) {
        return createVenueAddress(venueId, {
          address_line_1: data.addressLine1,
          address_post_code: data.postcode,
          address_town: data.town,
          email: data.email,
          country: data.countryCode,
          phone_landline: data.phoneNumber,
        });
      }

      if (addressId && hasValues) {
        return updateVenueAddress(
          venueId,
          {
            address_line_1: data.addressLine1,
            address_post_code: data.postcode,
            address_town: data.town,
            email: data.email,
            country: data.countryCode,
            phone_landline: data.phoneNumber,
          },
          addressId,
        );
      }

      if (addressId && !hasValues) {
        return deleteVenueAddress(venueId, addressId);
      }
      return Promise.resolve();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['venue', venueId] });
      onSuccess();
    },
    onError: (e) => {
      posthog.captureException(e);
      showSnackbar({
        status: SnackbarStatus.ERROR,
        message: 'Unable to update venue contact information',
      });
    },
  });
};
